<app-relatorio-container
    tituloRelatorio="Composição Efetiva"
    descricaoRelatorio="Composição efetiva (diretoria e conselheiros) do órgão/delegacia da UF informada."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'composicao-orgao.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div [formGroup]="form" class="flex flex-col gap-6">
            <div class="field">
                <label class="font-semibold block mb-2">UF <span class="text-red-500">*</span></label>
                <app-estado-select [uf]="form.get('uf')?.value ?? ''" (ufChange)="changeUf($event)" [removeBR]="true" (touched)="marcarUfTocada()"></app-estado-select>
                @if (!form.get('uf')?.value && ufTocada) {
                    <small class="p-error mt-2" style="color: red">Selecione a UF.</small>
                }
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Relatório" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isLoading()" [disabled]="gerarBloqueado"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
